import React, { useEffect, useState } from 'react';
import { Card, CardTitle, Metric } from '../components/UI';
import { getAnalyticsMetrics } from '../api';

const LABELS = {
  freight_spend_30d: '30-day freight spend',
  ai_savings: 'AI savings',
  cost_per_mile: 'Cost / mile',
  empty_mile_rate: 'Empty-mile rate',
};

export default function Analytics() {
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setMetrics(await getAnalyticsMetrics());
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const items = metrics
    ? [
        { label: LABELS.freight_spend_30d, value: metrics.freight_spend_30d },
        { label: LABELS.ai_savings, value: metrics.ai_savings },
        { label: LABELS.cost_per_mile, value: metrics.cost_per_mile },
        { label: LABELS.empty_mile_rate, value: metrics.empty_mile_rate },
      ]
    : [];

  return (
    <div className="space-y-[18px]">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {metrics
          ? items.map((m) => <Metric key={m.label} label={m.label} value={m.value} />)
          : Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="rounded-[10px] p-3.5 animate-pulse h-[70px]"
                style={{ background: '#fafbfc', border: '1px solid var(--lf-line)' }}
              />
            ))}
      </div>
      <Card>
        <CardTitle>What the AI is optimizing</CardTitle>
        <p className="leading-[1.7] text-sm" style={{ color: '#475467' }}>
          Total landed transportation cost, delivery-window compliance, equipment constraints,
          driver-hour feasibility, route risk, and opportunities to consolidate compatible loads.
        </p>
      </Card>
    </div>
  );
}
